import { ReactNode } from 'react'

import { Box } from '@factorialco/deprecated-design-system'
import { F0TagStatus, StatusVariant } from '@factorialco/f0-react'

export const SectionWithStatus: React.FC<{
  tagLabel: string
  statusVariant: StatusVariant
  count?: number
  children: ReactNode
}> = ({ tagLabel, statusVariant, count, children }) => {
  const tagtext = tagLabel + (count !== undefined ? ` (${count})` : '')

  return (
    <Box gap="s16">
      <F0TagStatus text={tagtext} variant={statusVariant} />
      <>{children}</>
    </Box>
  )
}
